import {Text} from '@primer/react'

/** Visually hidden text that will still be read by a screen reader. Link with aria-describedby. */
export const HiddenDescription = ({children, id}: {children: React.ReactNode; id: string}) => (
  // Normally display:none will not be read, but it will when used as a description
  // https://www.tpgi.com/short-note-on-aria-labelledby-and-aria-describedby/
  <Text sx={{display: 'none'}} id={id} aria-live="polite">
    {children}
  </Text>
)

try{ HiddenDescription.displayName ||= 'HiddenDescription' } catch {}